export const getStatusBadgeColors = (status) => {
  if (!status) {
    return { bg: '#f5f5f5', text: '#777' };
  }

  const normalized = String(status).toLowerCase();

  if (normalized.includes('recruit')) {
    return { bg: '#e8f5e9', text: '#2e7d32' };
  }

  if (normalized.includes('not yet')) {
    return { bg: '#e3f2fd', text: '#1565c0' };
  }

  if (normalized.includes('active')) {
    return { bg: '#fff3e0', text: '#ef6c00' };
  }

  if (normalized.includes('complete')) {
    return { bg: '#eeeeee', text: '#616161' };
  }

  return { bg: '#f5f5f5', text: '#777' };
};
